/**
 * Schema de filtros da listagem unificada de operações de crédito
 * (GET /contracts/receivables_assignment/list → credit.vw_list_operations).
 *
 * Consumido pelo FilterBuilder; os params saem no formato filter[campo][operador]
 * (ver molecules/FilterBuilder/serialize.ts) e o contracts-management lê essa mesma
 * convenção em infra/repositories/query_filters.py.
 */
import { FilterSchema } from '../../../molecules/FilterBuilder/types';

export const operationTypeOptions = [
    { value: 'LOAN', label: 'Empréstimo' },
    { value: 'RECEIVABLES_ASSIGNMENT', label: 'Cessão de recebíveis' },
    { value: 'STRUCTURED_OPERATION', label: 'Operação estruturada' },
    { value: 'ACKNOWLEDGEMENT_OF_DEBT', label: 'Confissão de dívida' },
];

export const creditProductTypeOptions = [
    { value: 'AVAL SIMPLES', label: 'Aval simples' },
    { value: 'AVAL DUPLO', label: 'Aval duplo' },
    { value: 'FIRST LOSS', label: 'First loss' },
    { value: 'FORFAITING', label: 'Forfaiting' },
    { value: 'CPRF PJ', label: 'CPRF PJ' },
    { value: 'CESSAO', label: 'Cessão' },
    { value: 'CONTRACT_ASSIGNMENT', label: 'Cessão de contrato' },
    { value: 'CASH_COLLATERAL', label: 'Cash collateral' },
];

export const operationsFilterSchema: FilterSchema[] = [
    // ─── Visíveis por padrão ──────────────────────────────────────────────────
    { key: 'sequencial_number', label: 'Nº Contrato', type: 'text', operators: ['contains', 'eq', 'starts_with'], defaultOperator: 'contains', visible: true },
    { key: 'amendment_number', label: 'Nº Aditamento', type: 'number', operators: ['eq', 'gte', 'lte'], defaultOperator: 'eq', visible: true },

    // ─── Disponíveis em "+ Filtro" ────────────────────────────────────────────
    { key: 'participant_document', label: 'CPF/CNPJ participante', type: 'text', operators: ['eq', 'contains'], defaultOperator: 'eq', visible: false },
    { key: 'participant_name', label: 'Nome / Razão social', type: 'text', operators: ['contains', 'eq', 'starts_with'], defaultOperator: 'contains', visible: false },
    { key: 'operation_type', label: 'Tipo de operação', type: 'enum', operators: ['in', 'not_in'], defaultOperator: 'in', visible: false, options: operationTypeOptions },
    { key: 'credit_product_type_name', label: 'Produto de crédito', type: 'enum', operators: ['in', 'not_in'], defaultOperator: 'in', visible: false, options: creditProductTypeOptions },
    { key: 'with_recourse', label: 'Com regresso', type: 'boolean', operators: ['is_true', 'is_false'], defaultOperator: 'is_true', visible: false },
    { key: 'originator', label: 'CPF/CNPJ originador', type: 'text', operators: ['eq', 'contains'], defaultOperator: 'eq', visible: false },
    { key: 'expiration_date', label: 'Vencimento', type: 'date', operators: ['between_dates', 'before', 'after'], defaultOperator: 'between_dates', visible: false },
    { key: 'approved_on', label: 'Data de aprovação', type: 'date', operators: ['between_dates', 'before', 'after'], defaultOperator: 'between_dates', visible: false },
    { key: 'emission_date', label: 'Emissão', type: 'date', operators: ['between_dates', 'before', 'after'], defaultOperator: 'between_dates', visible: false },
    { key: 'created_at', label: 'Criação', type: 'date', operators: ['between_dates', 'before', 'after'], defaultOperator: 'between_dates', visible: false },
    { key: 'approved_value', label: 'Valor aprovado', type: 'number', operators: ['between', 'gte', 'lte', 'eq'], defaultOperator: 'between', visible: false },
    { key: 'nominal_value', label: 'Valor nominal', type: 'number', operators: ['between', 'gte', 'lte', 'eq'], defaultOperator: 'between', visible: false },
    // TODO (a confirmar): manter ou remover `loan_amount` como filtro.
    { key: 'loan_amount', label: 'Valor do empréstimo', type: 'number', operators: ['between', 'gte', 'lte', 'eq'], defaultOperator: 'between', visible: false },
    { key: 'current_balance', label: 'Saldo atual', type: 'number', operators: ['between', 'gte', 'lte', 'eq'], defaultOperator: 'between', visible: false },
];
